var url = window.location.href;
cleanUrl = url.split('.html')[0];
window.history.replaceState( null, null, cleanUrl );